import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import SBProBorder from '@structural/border.vue';
let SBProPageHeader = class SBProPageHeader extends Vue {
};
__decorate([
    Prop()
], SBProPageHeader.prototype, "headerClasses", void 0);
__decorate([
    Prop()
], SBProPageHeader.prototype, "borderType", void 0);
__decorate([
    Prop({ default: 'text-white' })
], SBProPageHeader.prototype, "borderClasses", void 0);
__decorate([
    Prop()
], SBProPageHeader.prototype, "backgroundImage", void 0);
SBProPageHeader = __decorate([
    Component({
        components: {
            'sbpro-border': SBProBorder,
        },
    })
], SBProPageHeader);
export default SBProPageHeader;
